import { Flex } from 'native-base';
import PropTypes from 'prop-types';
import React from 'react';

import Face from './Face';

function FacesDisplay({ faces }) {
  return (
    <Flex
      m="2"
      py="2"
      direction="row"
      flexWrap="wrap"
      justifyContent="space-between"
    >
      {faces.map((item) => (
        <Face key={item.index} face={item.face} />
      ))}
    </Flex>
  );
}

FacesDisplay.propTypes = {
  faces: PropTypes.array.isRequired,
};

export default FacesDisplay;
